export const underlineStyle = {
    textDecorationLine: "underline",
    textDecorationStyle: "dashed",
  }